import type { BundleMediaAsset } from '@/types/api'
import { isImageType } from '@/utils/mediaUtils'

export const mediaLabel = (asset: BundleMediaAsset) =>
  asset.mediaTitle?.trim() || asset.displayName || asset.originalFileName

export function sortGalleryMedia(media: BundleMediaAsset[]): BundleMediaAsset[] {
  return [...media].sort((a, b) =>
    mediaLabel(a).localeCompare(mediaLabel(b), undefined, { numeric: true, sensitivity: 'base' }),
  )
}

export const galleryImages = (media: BundleMediaAsset[] | undefined): BundleMediaAsset[] =>
  sortGalleryMedia((media ?? []).filter((m) => isImageType(m.mimeType)))

/** Width / height of an SVG document from its viewBox, else its numeric width and height attributes. */
export function svgAspectRatio(svg: string): number | null {
  const tag = /<svg\b[^>]*>/i.exec(svg)?.[0]
  if (!tag) return null
  const attr = (name: string) => new RegExp(`\\s${name}\\s*=\\s*["']([^"']*)["']`, 'i').exec(tag)?.[1]

  const viewBox = attr('viewBox')?.trim().split(/[\s,]+/).map(Number)
  if (viewBox?.length === 4 && viewBox[2] > 0 && viewBox[3] > 0) return viewBox[2] / viewBox[3]

  // Percentages describe the container, not the drawing, so only plain or px lengths count.
  const length = (name: string) => {
    const value = attr(name)?.trim() ?? ''
    return /^\d*\.?\d+(px)?$/i.test(value) ? parseFloat(value) : 0
  }
  const width = length('width')
  const height = length('height')
  return width > 0 && height > 0 ? width / height : null
}
